<template>
  <transition name="slide-fade" >
    <div class="scroll-post__description" v-if="showSlideShow">
      <div v-for="slide in slides"
           :key="slide.id"
           :style="getDescriptionStyle(slide)"
           class="description-list">
        <cmscontent :content="slide.excerpt"/>
        <cmslink v-if="slide.link" :link="slide" text="Read more" class="button" :style="{backgroundColor: slide.color, color: slide.color}" :class="slide.buttonClass"/>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: ['slides', 'getPercent', 'showSlideShow'],
    methods: {
      getDescriptionStyle(slide) {
        const step = 250;
        const {position, relativePosition, relativePositionFloat} = this.getPercent(slide);
        const top = (relativePositionFloat) * step;
        const opacity = 1 - 9 * Math.pow(relativePositionFloat, 2);
        const display = opacity <= 0 ? 'none' : undefined;
        return {
          opacity,
          display,
          top: top + 'px',
        };
      },

    },
  };
</script>

